import styled from "styled-components";

import DefaultRow from "components/Form/Row";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const ControlHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ControlContainer = styled.div``;

export const Row = styled(DefaultRow)`
  margin-bottom: 0;

  :not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const MovementCards = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;
